<template lang="pug">
  m-table(
    store-name="adminacts"
    :query-filter="queryFilter"
    :headers="headers"
    :item-actions="actions"
  )
</template>

<script>
import Download from 'js-file-download'
import MTable from '~/components/modules/tables/m-table'

export default {
  name: 'BlockOrganizationActs',
  components: { MTable },
  props: {
    organizationId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Act number',
          value: 'number',
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization name',
          value: 'organization.name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Edrpou',
          value: 'organization.edrpou',
          sortable: false,
          filterable: false
        },
        {
          text: 'Sum, uah',
          valueFormatter: act => (act.sum / 100).toFixed(2),
          sortable: false,
          filterable: false
        },
        {
          text: 'Period (from - to)',
          value: 'startDate',
          valueFormatter: act =>
            this.$moment.parseZone(act.startDate).format('DD.MM.YYYY') +
            ' - ' +
            this.$moment.parseZone(act.endDate).format('DD.MM.YYYY'),
          sortable: false,
          filterable: false
        },
        {
          text: 'Date of sending',
          valueFormatter: act =>
            act.sendDate ? this.$moment.parseZone(act.sendDate).format('DD.MM.YYYY, HH:mm') : '-',
          sortable: false,
          filterable: false
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          width: '120',
          sortable: false,
          filterable: false
        }
      ]
    },
    actions() {
      return [
        {
          name: 'download',
          text: 'Download',
          icon: 'arrow-download',
          call: act => this.downloadAct(act)
        }
      ]
    },
    queryFilter() {
      return {
        'organization.id': this.organizationId
      }
    }
  },
  methods: {
    async downloadAct(act) {
      try {
        const blob = await this.$store.dispatch('adminacts/downloadAct', act?.id)
        if (blob) {
          Download(blob, `act-${act.number}.pdf`)
        }
      } catch (e) {
        this.$handlers.error(e, this)
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
